import React, { ChangeEvent, startTransition, useCallback, useEffect, useState } from 'react';
import AppHeader from '../../common/app-header/AppHeader';
import { TextValidator, ValidatorForm } from '../../common/form-validator';
import { normalizeEmailInput } from '../../common/utils/email';
import Button from '@mui/material/Button';
import { ProgressOverlay } from '../../common/progress-overlay/ProgressOverlay';
import { useTranslation } from 'react-i18next';
import Brand from '../../../assets/svg/brand.svg?react';
import {
  Avatar,
  Box,
  Card,
  Checkbox,
  Chip,
  CircularProgress,
  Divider,
  FormControlLabel,
  FormHelperText,
  Grid,
  Radio,
  RadioGroup,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import EmploymentSettingsIcon from '../../../assets/svg/menu/profile-icon.svg?react';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useAppSelector } from '../../common/hooks/useAppSelector';
import { useAppDispatch } from '../../common/hooks/useAppDispatch';
import dayjs, { Dayjs } from 'dayjs';
import { fetchCompanies, selectAllCompanies } from '../../slices/companies/companiesSlice';
import { useNavigate, useParams } from 'react-router-dom';
import QualificationsIcon from '../../../assets/svg/menu/qualifications.svg?react';
import EmergencySettingsIcon from '../../../assets/svg/menu/emergency.svg?react';
import { BLACK_COLOR, LIGHT_GREY } from '../../common/constants/colors';
import { RELATIONSHIP } from '../../common/constants/relationship';
import { POSITION_TYPES } from '../../common/constants/position_types';
import { NWClient } from '../../client/NWClient';
import { toast } from 'react-toastify';
import 'dayjs/locale/en-gb';
import { Company } from '../../models/company.model';
import { Employee } from '../../models/employee.model';
import {
  createEmployee,
  fetchEmployees,
  selectEmployeeById,
} from '../../slices/employees/employeesSlice';
import { RootState } from '../../store';
import { ROUTES } from '../../common/constants/routes';
import Tooltip from '@mui/material/Tooltip';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import IconButton from '@mui/material/IconButton';
import DialogItem from '../../common/dialog-item/DialogItem';
import CloseIcon from '@mui/icons-material/Close';
import DescriptionIcon from '@mui/icons-material/Description';
import { Helpers } from '../../common/helpers/helpers';
import PopoverWithButton from '../../common/popover-with-button/PopoverWithButton';
import { showMessage } from '../../slices/show-plan-upgrading-message/showPlanUpgradingMessage';
import { useAuth, useOrganization } from '@clerk/clerk-react';
import MessageModal from '../../common/message-modal/MessageModal';
import InfoIcon from '@mui/icons-material/Info';
import { useErrorMessage } from '../../common/hooks/useErrorMessage';

const EmployeeProfilePageForAdmin = () => {
  const { userId } = useParams();
  const company = useAppSelector(selectAllCompanies)[0];
  const employee = useAppSelector((state: RootState) => selectEmployeeById(state, Number(userId)));
  const dispatch = useAppDispatch();
  const [pendingStatus, setPendingStatus] = useState(false);
  const [inviteEmail, setInviteEmail] = useState<string | null>('');
  const [employeeUserId, setEmployeeUserId] = useState<number | null>(null);
  const [email, setEmail] = useState<string | null>('');
  const [fullName, setFullName] = useState<string | null>('');

  const [address, setAddress] = useState<string | null>('');
  const [phoneNumber, setPhoneNumber] = useState<string | null>('');
  const [positionTitle, setPositionTitle] = useState<string>('');
  const [positionType, setPositionType] = useState<string | null>('');
  const [department, setDepartment] = useState<string | null>('');
  const [startDate, setStartDate] = useState<Dayjs | null>(null);
  const [endDate, setEndDate] = useState<Dayjs | null>(null);
  const [emailBusiness, setEmailBusiness] = useState<string | null>('');
  const [taxNumber, setTaxNumber] = useState<string | null>('');
  const [employeeId, setEmployeeId] = useState<string | null>('');
  const [positionDescription, setPositionDescription] = useState<string | null>('');
  const [degree, setDegree] = useState<string>('');
  const [universityName, setUniversityName] = useState<string | null>('');
  const [startDateQualifications, setStartDateQualifications] = useState<Dayjs | null>(null);
  const [endDateQualifications, setEndDateQualifications] = useState<Dayjs | null>(null);
  const [fullNameEmergency, setFullNameEmergency] = useState<string>('');
  const [emailEmergency, setEmailEmergency] = useState<string | null>('');
  const [addressEmergency, setAddressEmergency] = useState<string | null>('');
  const [phoneNumberEmergency, setPhoneNumberEmergency] = useState<string | null>('');
  const [relationship, setRelationship] = useState<string>('');
  const [fieldsErrors, setFieldsErrors] = useState<Record<string, string[]> | null>(null);
  const [editMode, setEditMode] = useState<boolean>(!userId);
  const [deleteEmployeeMessageVisible, setDeleteEmployeeMessageVisible] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(true);
  const { t } = useTranslation();
  const { getErrorMessage } = useErrorMessage();
  const navigate = useNavigate();
  const canSubmit = true;
  const [openInvite, setOpenInvite] = useState<boolean>(false);
  const [employeeDocuments, setEmployeeDocuments] = useState([]);
  const [bothEmailsSet, setBothEmailsSet] = useState(false);
  const [invitationEmail, setInvitationEmail] = useState('');
  const [inviteChecked, setInviteChecked] = useState(false);
  const [isInviteDialogOpen, setIsInviteDialogOpen] = useState(false);

  const { invitations, memberships, organization } = useOrganization({
    invitations: true,
    memberships: true,
  });

  const { userId: clerkUserId } = useAuth();

  const members = memberships?.data;
  const invitationList = invitations?.data;

  const isMember = members?.find(
    (mem) =>
      mem.publicUserData?.identifier === email || mem.publicUserData?.identifier === emailBusiness
  );

  const disableInvite =
    (email == null || email.trim().length == 0) &&
    (emailBusiness == null || emailBusiness.trim().length == 0);

  const hasInvite = invitationList?.find(
    (invite) => invite.emailAddress === email || invite.emailAddress === emailBusiness
  );

  const hideInvite = Boolean(isMember) || Boolean(hasInvite);

  const handleCloseDialog = () => {
    setIsInviteDialogOpen(false);
  };

  const handleOkDialog = () => {
    setIsInviteDialogOpen(false);
    createEmployeeFn();
  };

  const handleEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInvitationEmail(value);
  };

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const isChecked = event.target.checked;
    setInviteChecked(isChecked);
  };

  const submitEmployment = (company: Company) => {
    if (!employee) return;
    const data = {
      position_title: positionTitle,
      position_description: positionDescription,
      position_type: positionType,
      department: department,
      employee_tax_number: taxNumber,
      employee_id: employee.id,
      employee_identification_number: employeeId,
      start_date: startDate ? startDate.toISOString().substring(0, 10) : null,
      end_date: endDate ? endDate.toISOString().substring(0, 10) : null,
    };

    if (employee.employments.length === 0) {
      NWClient.post(`employee/${employee.id}/employments`, data, true)
        .then(() => {
          submitQualification(company);
        })
        .catch(() => {
          setPendingStatus(false);
          toast.error('A profile with the same name already exists.');
        });
    } else {
      NWClient.put(
        `employee/${employee.id}/employments`,
        Math.max(...employee.employments.map((el: any) => el.id)),
        data,
        true,
        true
      )
        .then(() => {
          submitQualification(company);
        })
        .catch((error) => {
          setPendingStatus(false);
          toast.error(getErrorMessage(error));
        });
    }
  };
  const submitEmergencyContact = (company: Company) => {
    if (!employee) return;
    const data = {
      full_name: fullNameEmergency,
      postal_address: addressEmergency,
      email_address: emailEmergency,
      relationship,
      phone_number: phoneNumberEmergency,
    };
    if (!employee.emergency_contact) {
      NWClient.post(`employee/${employee.id}/emergency_contact`, data, true)
        .then(() => {
          dispatch(fetchCompanies()); //to refactor
          setPendingStatus(false);
          setFieldsErrors(null);
          toast.success(t('messages.userDataUpdated'));
        })
        .catch((error) => {
          setPendingStatus(false);
          setFieldsErrors(error?.response?.data);
          toast.error(getErrorMessage(error));
        });
    } else {
      NWClient.put(
        `employee/${employee.id}/emergency_contact`,
        employee.emergency_contact.id,
        data,
        true,
        true
      )
        .then(() => {
          dispatch(fetchEmployees({ company_id: company.id ?? 0 })); //to refactor
          setPendingStatus(false);
          setFieldsErrors(null);
          toast.success(t('messages.userDataUpdated'));
        })
        .catch((error) => {
          setPendingStatus(false);
          setFieldsErrors(error?.response?.data);
          toast.error(getErrorMessage(error));
        });
    }
  };

  const submitQualification = (company: Company) => {
    if (!employee) return;
    const data = {
      degree,
      university_name: universityName,
      start_date: startDateQualifications
        ? startDateQualifications.toISOString().substring(0, 10)
        : null,
      end_date: endDateQualifications ? endDateQualifications.toISOString().substring(0, 10) : null,
    };
    if (employee.qualifications.length === 0) {
      NWClient.post(`employee/${employee.id}/qualifications`, data, true)
        .then(() => {
          submitEmergencyContact(company);
        })
        .catch((error) => {
          setPendingStatus(false);
          toast.error(getErrorMessage(error), { theme: 'colored' });
        });
    } else {
      NWClient.put(
        `employee/${employee.id}/qualifications`,
        employee.qualifications[0].id,
        data,
        true,
        true
      )
        .then(() => {
          submitEmergencyContact(company);
        })
        .catch((error) => {
          setPendingStatus(false);
          toast.error(getErrorMessage(error));
        });
    }
  };
  const handleMenuClick = () => {
    setOpenInvite(true);
  };
  const handleMenuClose = () => {
    setOpenInvite(false);
  };
  const handleInvite = (email: string) => {
    setLoading(true);
    NWClient.post(
      `user/invite-existing`,
      { email: email, company_id: company?.id },
      false,
      `?fehost=${window.location.host}`
    ).then(() => {
      setLoading(false);
      handleMenuClose();
      toast.success(t('messages.employeeInvited') + email + '.', { theme: 'colored' });
    });
  };

  const createEmployeeFn = () => {
    setPendingStatus(true);
    const data = {
      email_address: (email ?? '').toLowerCase(),
      business_email_address: (emailBusiness ?? '').toLowerCase(),
      company_id: company?.id,
      full_name: fullName ?? undefined,

      address: address ?? undefined,
      contact_number: phoneNumber ?? undefined,
    };
    if (!userId) {
      dispatch(createEmployee(data))
        .unwrap()
        .then((res: Employee) => {
          if (inviteChecked && invitationEmail !== null && invitationEmail.trim().length !== 0) {
            NWClient.sendInvitation({
              inviter: clerkUserId ?? '',
              organization: organization?.id ?? '',
              target: invitationEmail,
            })
              .then(() => {
                toast.success(t('messages.invitationSentToEmployee'), { theme: 'colored' });
                window.location.href = `${ROUTES.EMPLOYEE_PROFILES}/${res.id}`;
                //navigate(`${ROUTES.EMPLOYEE_PROFILES}/${res.id}`);return;
              })
              .catch((reason) => {
                toast.error(
                  `Employee created, but invitation to ${invitationEmail} could not be sent: ${reason}`
                );
                window.location.href = `${ROUTES.EMPLOYEE_PROFILES}/${res.id}`;
                //navigate(`${ROUTES.EMPLOYEE_PROFILES}/${res.id}`);
                return;
              });
          }

          toast.success(t('messages.employeeCreated'));
          window.location.href = `${ROUTES.EMPLOYEE_PROFILES}/${res.id}`;
          //navigate(`${ROUTES.EMPLOYEE_PROFILES}/${res.id}`);
        })
        .catch((error) => {
          setFieldsErrors(error?.response?.data);
          if (
            error.response?.data?.errors?.length > 0 &&
            (error.response?.data?.errors[0] === t('messages.exceededPlanLimits') ||
              t('messages.exceededPlanLimits').includes(error.response?.data?.errors[0]))
          ) {
            dispatch(showMessage(t('messages.limitEmployees')));
          } else {
            toast.error(getErrorMessage(error), { theme: 'colored' });
          }
        })
        .finally(() => {
          setPendingStatus(false);
        });
    } else {
      NWClient.put('employee', Number(userId), data, true)
        .then(() => {
          submitEmployment(company);
        })
        .catch((error) => {
          setFieldsErrors(error.response.data);
          setPendingStatus(false);
          toast.error(getErrorMessage(error));
        });
    }
  };
  const handleSubmit = (e: React.SyntheticEvent) => {
    const bothEmailsSet =
      email !== null &&
      email.trim().length !== 0 &&
      emailBusiness !== null &&
      emailBusiness.trim().length !== 0 &&
      email.trim() !== emailBusiness.trim();
    setBothEmailsSet(bothEmailsSet);
    if (!bothEmailsSet) {
      if (email !== null && email.trim().length !== 0) {
        setInvitationEmail(email.toLowerCase());
      } else {
        setInvitationEmail((emailBusiness ?? '').toLowerCase());
      }
    }
    if (inviteChecked) {
      setIsInviteDialogOpen(inviteChecked);
      return;
    }
    e.preventDefault();
    createEmployeeFn();
  };

  const handleNavigateByRowClick = (row: any) => {
    navigate(
      `${ROUTES.DOCUMENT_VAULT}/employment/${row.id}${
        row.contract_generation ? '?initialTab=0&contractGenerated=true' : ''
      }`
    );
  };

  const setDetails = useCallback(() => {
    const userDetails = employee;
    if (employee) {
      setEmployeeUserId(employee.user ? employee.user : null);
      setEmail(employee.email_address ? employee.email_address.toLowerCase() : '');
      setInviteEmail(
        employee.business_email_address ? employee.business_email_address.toLowerCase() : ''
      );
      setAddress(employee.address ? employee.address : '');
      setFullName(employee.full_name ? employee.full_name : '');

      setPhoneNumber(employee.contact_number ? employee.contact_number : '');
      setEmailBusiness((employee.business_email_address ?? '').toLowerCase());
    }
    if (userDetails) {
      if (userDetails.employments.length > 0) {
        const employmentsId = Math.max(...employee.employments.map((el: any) => el.id));
        const employmentInstance = userDetails.employments.find(
          (el: any) => el.id === employmentsId
        );
        if (employmentInstance) {
          setEmployeeId(
            employmentInstance.employee_identification_number
              ? employmentInstance.employee_identification_number
              : ''
          );
          setPositionTitle(employmentInstance.position_title ?? '');
          setDepartment(employmentInstance.department ?? '');
          setTaxNumber(employmentInstance.employee_tax_number ?? '');
          setPositionType(employmentInstance.position_type ?? '');
          setPositionDescription(employmentInstance.position_description ?? '');
          setStartDate(
            employmentInstance.start_date ? dayjs(new Date(employmentInstance.start_date)) : null
          );
          setEndDate(
            employmentInstance.end_date ? dayjs(new Date(employmentInstance.end_date)) : null
          );
        }
      }
      if (userDetails.qualifications.length > 0) {
        const qualificationsId = Math.max(...employee.qualifications.map((el: any) => el.id));
        const qualificationsInstance = userDetails.qualifications.find(
          (el: any) => el.id === qualificationsId
        );
        if (qualificationsInstance) {
          setDegree(qualificationsInstance.degree ?? '');
          setUniversityName(qualificationsInstance.university_name ?? '');
          setStartDateQualifications(
            qualificationsInstance.start_date
              ? dayjs(new Date(qualificationsInstance.start_date))
              : null
          );
          setEndDateQualifications(
            qualificationsInstance.end_date
              ? dayjs(new Date(qualificationsInstance.end_date))
              : null
          );
        }
      }
      if (userDetails.emergency_contact) {
        const emergencyContactInstance = userDetails.emergency_contact;
        setFullNameEmergency(emergencyContactInstance.full_name ?? '');
        setEmailEmergency((emergencyContactInstance.email_address ?? '').toLowerCase());
        setAddressEmergency(emergencyContactInstance.postal_address ?? '');
        setRelationship(emergencyContactInstance.relationship ?? '');
        setPhoneNumberEmergency(emergencyContactInstance.phone_number ?? '');
      }
    }
  }, [employee]);

  const positionTypeArray = POSITION_TYPES.map((el) => t(el));
  const relationshipArray = RELATIONSHIP.map((el) => t(el));

  const fetchEmployeeDocuments = useCallback(
    (id: number) => {
      NWClient.list('document-upload')
        .then((res) => {
          const employeeDocuments = res.filter((el: any) => el.employees.includes(id));
          setEmployeeDocuments(employeeDocuments);
        })
        .catch((error) => {
          toast.error(getErrorMessage(error), { theme: 'colored' });
        });
    },
    [getErrorMessage]
  );

  const deleteEmployee = () => {
    setPendingStatus(true);
    NWClient.delete('employee', userId ?? '')
      .then(() => {
        toast.success(t('messages.employeeDeleted'));
        dispatch(fetchEmployees({ company_id: company?.id ?? 0 }))
          .unwrap()
          .then(() => {
            navigate(ROUTES.EMPLOYEE_PROFILES);
          })
          .catch((error) => {
            setPendingStatus(false);
            toast.error(getErrorMessage(error));
          });
      })
      .catch((error) => {
        setPendingStatus(false);
        toast.error(getErrorMessage(error));
      });
  };

  useEffect(() => {
    if (!userId) {
      startTransition(() => setLoading(false));
    }
  }, [userId]);

  useEffect(() => {
    if (employee) {
      startTransition(() => {
        setLoading(false);
        setDetails();
      });
      fetchEmployeeDocuments(employee.id);
    } else {
      dispatch(fetchEmployees({ company_id: company?.id ?? 0 }))
        .then(() => {
          setDetails();
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [company, employee, dispatch, setDetails, fetchEmployeeDocuments]);
  return (
    <>
      <AppHeader title={userId ? t('employeeProfiles.header') : t('pages.createEmployee')} />
      {loading ? (
        <Box sx={{ textAlign: 'center' }}>
          {/*<CircularProgress/>*/}
          <ProgressOverlay position='relative' />
        </Box>
      ) : (
        <div className='profile-details-wrapper'>
          <Grid component='div'>
            <div>
              <ValidatorForm onSubmit={handleSubmit}>
                <div className='basic-info'>
                  <Grid
                    component='div'
                    sx={{
                      width: { xs: '100%', md: '50%' },
                      marginBottom: '20px',
                      border: 'none',
                      boxShadow: 'none',
                      borderRadius: 0,
                    }}
                    container
                    style={{ alignItems: 'center', flexWrap: 'wrap', gap: '8px' }}
                  >
                    {employee?.full_name && (
                      <Box
                        className='invite-employees-item-avatar'
                        sx={{ display: 'flex', justifyContent: 'center' }}
                      >
                        <Avatar
                          sx={{
                            width: 80,
                            height: 80,
                            marginRight: '1rem',
                            fontSize: '2rem',
                            backgroundColor: LIGHT_GREY,
                            color: BLACK_COLOR,
                          }}
                        >{`${
                          employee && employee.full_name
                            ? employee.full_name[0]
                            : employee.email_address
                        }`}</Avatar>
                      </Box>
                    )}
                    {userId && (
                      <h2>
                        {`${employee && employee.full_name ? employee.full_name + ' ' : ''}}`}
                      </h2>
                    )}
                    {userId && (
                      <>
                        {!editMode && !employeeUserId && (
                          <Button
                            id='employeeProfilePageForAdminMenuBtn'
                            sx={{ marginLeft: { xs: 0, md: '24rem' } }}
                            variant='outlined'
                            size='large'
                            disabled={loading}
                            onClick={handleMenuClick}
                          >
                            {loading ? (
                              <CircularProgress
                                id='employeeProfilePageForAdminMenuBtnSpinner'
                                size={24}
                              />
                            ) : (
                              t('buttons.inviteEmployee')
                            )}
                          </Button>
                        )}
                        {openInvite && (
                          <DialogItem
                            isErrorMessage={false}
                            open={openInvite}
                            title={`${t('dialogTitles.chooseEmail')} ${fullName} ${t(
                              'dialogTitles.chooseEmail2'
                            )}`}
                            noDefaultActionsRow={true}
                            handleClose={() => handleMenuClose()}
                          >
                            <IconButton
                              id='employeeProfilePageForAdminMenuCloseIconBtn'
                              style={{ position: 'absolute', top: 8, right: 8 }}
                              onClick={handleMenuClose}
                            >
                              <CloseIcon id='employeeProfilePageForAdminMenuCloseIconBtnCloseIcon' />
                            </IconButton>
                            <Grid component='div' size={{ xs: 12, md: 6 }}>
                              <InputLabel htmlFor='emailAddress'>
                                {t('labels.emailAddress')}
                              </InputLabel>
                              <Select
                                onChange={(e) => {
                                  setInviteEmail(e.target.value);
                                }}
                                id='inviteEmail'
                                name='inviteEmail'
                                value={inviteEmail}
                                sx={{ width: '100%' }}
                              >
                                <MenuItem
                                  id='employeeProfilePageForAdminInviteEmailMenuItem'
                                  value={email ?? ''}
                                  onClick={() => {
                                    setInviteEmail(email);
                                  }}
                                >
                                  {email}
                                </MenuItem>
                                <MenuItem
                                  id='employeeProfilePageForAdminInviteEmailMenuItem2'
                                  value={emailBusiness ?? ''}
                                  onClick={() => {
                                    setInviteEmail(emailBusiness);
                                  }}
                                >
                                  {emailBusiness}
                                </MenuItem>
                              </Select>
                            </Grid>
                            <Box
                              className='buttons-row'
                              sx={{
                                display: 'flex',
                                flexWrap: 'wrap',
                                justifyContent: 'flex-end',
                                marginTop: 3,
                              }}
                            >
                              <Button
                                id='employeeProfilePageForAdminInviteBtn'
                                type='button'
                                role='button'
                                variant='contained'
                                size='medium'
                                style={{ marginLeft: '0.5rem', marginBottom: '0.5rem' }}
                                onClick={() => handleInvite(inviteEmail ?? '')}
                              >
                                {t('buttons.invite')}
                              </Button>
                            </Box>
                          </DialogItem>
                        )}
                        <Button
                          id='employeeProfilePageForAdminUpdateBtn'
                          style={{ marginLeft: 'auto' }}
                          variant='outlined'
                          type={editMode ? 'button' : 'submit'}
                          size='large'
                          onClick={(e) => {
                            if (editMode) {
                              dispatch(fetchCompanies());
                              handleSubmit(e);
                              setEditMode(false);
                            } else {
                              setEditMode(true);
                            }
                          }}
                        >
                          {!editMode ? t('buttons.edit') : t('buttons.update')}
                        </Button>
                        {!employeeUserId && (
                          <IconButton
                            id='employeeProfilePageForAdminDeleteIconBtn'
                            aria-label='delete'
                            style={{ marginLeft: '0.5rem' }}
                            onClick={() => setDeleteEmployeeMessageVisible(true)}
                          >
                            <Tooltip title={t('messages.deleteEmployee')} placement='top' arrow>
                              <DeleteOutlineOutlinedIcon
                                id='employeeProfilePageForAdminDeleteIconBtnDeleteOutlineIcon'
                                fontSize='large'
                                style={{ marginRight: 0 }}
                              />
                            </Tooltip>
                          </IconButton>
                        )}
                      </>
                    )}
                  </Grid>
                  <Card sx={{ padding: '16px' }}>
                    <Grid component='div' container className='form-controls' spacing={2}>
                      <Grid component='div' size={{ xs: 12, md: 6 }}>
                        <TextValidator
                          fullWidth
                          label={`${t('labels.fullName')} *`}
                          onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            setFullName(e.target.value)
                          }
                          name='fullName'
                          validators={['required']}
                          errorMessages={t('messages.fieldRequired')}
                          value={fullName}
                          disabled={!editMode}
                        />
                      </Grid>
                      <Grid component='div' size={{ xs: 12, md: 6 }}>
                        <TextValidator
                          fullWidth
                          type='email'
                          label={t('labels.email')}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            // Replace upper case letters as the value is typed.
                            setEmail(normalizeEmailInput(e.target.value));
                            if (disableInvite) {
                              setInviteChecked(false);
                            }
                          }}
                          name='email'
                          value={email}
                          disabled={!editMode}
                          validators={['isEmail']}
                          errorMessages={[t('messages.emailNotValid')]}
                          sx={{ '& input': { textTransform: 'lowercase !important' } }}
                          slotProps={{
                            htmlInput: {
                              inputMode: 'email',
                              autoCapitalize: 'none',
                              autoCorrect: 'off',
                              spellCheck: false,
                              maxLength: 254,
                            },
                          }}
                        />
                      </Grid>
                      <Grid component='div' size={{ xs: 12, md: 6 }}>
                        <TextValidator
                          fullWidth
                          type='email'
                          label={t('labels.businessEmailAddress')}
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            // Replace upper case letters as the value is typed.
                            setEmailBusiness(normalizeEmailInput(e.target.value));
                            if (disableInvite) {
                              setInviteChecked(false);
                            }
                          }}
                          name='emailBusiness'
                          value={emailBusiness}
                          disabled={!editMode}
                          validators={['isEmail']}
                          errorMessages={[t('messages.emailNotValid')]}
                          sx={{ '& input': { textTransform: 'lowercase !important' } }}
                          slotProps={{
                            htmlInput: {
                              inputMode: 'email',
                              autoCapitalize: 'none',
                              autoCorrect: 'off',
                              spellCheck: false,
                              maxLength: 254,
                            },
                          }}
                        />
                      </Grid>
                      <Grid component='div' size={{ xs: 12, md: 6 }}>
                        <TextValidator
                          fullWidth
                          label={t('labels.phoneNumber')}
                          onChange={(e: ChangeEvent<HTMLInputElement>) =>
                            setPhoneNumber(e.target.value)
                          }
                          name='phoneNumber'
                          disabled={!editMode}
                          value={phoneNumber}
                        />
                        {Boolean(fieldsErrors?.contact_number) && (
                          <FormHelperText error={true}>
                            {fieldsErrors?.contact_number?.join('.')}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid component='div' size={{ xs: 12, md: 6 }}>
                        <TextValidator
                          label={t('labels.physicalAddress')}
                          fullWidth
                          onChange={(e: ChangeEvent<HTMLInputElement>) => {
                            setAddress(e.target.value);
                          }}
                          disabled={!editMode}
                          name='address'
                          value={address}
                        />
                        {Boolean(fieldsErrors?.address) && (
                          <FormHelperText error={true}>
                            {fieldsErrors?.address?.join('.')}
                          </FormHelperText>
                        )}
                      </Grid>
                      <Grid component='div' size={{ xs: 12, md: 6 }}>
                        <div hidden={hideInvite}>
                          <Checkbox
                            id='inviteCheckBox'
                            checked={inviteChecked}
                            title={t('inviteEmployee')}
                            onChange={handleChange}
                            disabled={disableInvite}
                          />
                          <label
                            id='employeeProfilePageForAdminInviteEmployeeLabel'
                            htmlFor='inviteCheckBox'
                          >
                            <span
                              id='employeeProfilePageForAdminInviteEmployeeLabelText'
                              style={{ marginRight: '8px' }}
                            >
                              {t('inviteEmployee')}
                            </span>
                            <Tooltip
                              title={t('messages.inviteEmployeeMessage')}
                              arrow
                              placement='top'
                            >
                              <InfoIcon
                                id='employeeProfilePageForAdminInviteEmployeeLabelInfoIcon'
                                color='primary'
                                fontSize='small'
                                style={{ marginRight: '8px' }}
                              />
                            </Tooltip>
                          </label>
                        </div>
                      </Grid>
                    </Grid>
                  </Card>
                </div>
                {userId && (
                  <>
                    <Grid
                      component='div'
                      container
                      className='setting-panel-header'
                      style={{ alignItems: 'center' }}
                    >
                      <EmploymentSettingsIcon />
                      <h3>{t('settings.titles.employment')}</h3>
                    </Grid>
                    <Divider />
                    <div className='setting-panel-body'>
                      <Grid component='div' container className='form-controls' spacing={4}>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            label={t('labels.employeeId')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setEmployeeId(e.target.value)
                            }
                            name='employeeId'
                            value={employeeId}
                            disabled={!editMode}
                          />
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            label={t('labels.employeeTaxNumber')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setTaxNumber(e.target.value)
                            }
                            name='employeeTaxNumber'
                            value={taxNumber}
                            disabled={!editMode}
                          />
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            label={t('labels.positionTitle')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setPositionTitle(e.target.value)
                            }
                            name='positionTitle'
                            value={positionTitle}
                            disabled={!editMode}
                          />
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            label={t('labels.department')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setDepartment(e.target.value)
                            }
                            name='department'
                            value={department}
                            disabled={!editMode}
                          />
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            select
                            label={t('labels.positionType')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setPositionType(e.target.value)
                            }
                            disabled={!editMode}
                            name='positionType'
                            value={positionType}
                          >
                            {positionTypeArray.map((option) => (
                              <MenuItem
                                id={`employeeProfilePageForAdminPositionTypeArrayMenuItem_${option}`}
                                key={option}
                                value={option}
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </TextValidator>
                        </Grid>
                        <Grid
                          component='div'
                          size={{ xs: 12, md: 6 }}
                          className='datepicker-container'
                        >
                          <InputLabel id='startDateLabel'>{t('labels.startDate')}</InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
                            <DemoContainer components={['DatePicker']}>
                              <DatePicker
                                disabled={!editMode}
                                aria-labelledby='startDateLabel'
                                value={startDate}
                                format='DD.MM.YYYY'
                                onChange={(newValue) => setStartDate(newValue)}
                                slotProps={{
                                  field: { clearable: true },
                                }}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </Grid>
                        <Grid
                          component='div'
                          size={{ xs: 12, md: 6 }}
                          className='datepicker-container'
                        >
                          <InputLabel id='endDateLabel'>{t('labels.endDate')}</InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
                            <DemoContainer components={['DatePicker']}>
                              <DatePicker
                                disabled={!editMode}
                                format='DD.MM.YYYY'
                                aria-labelledby='endDateLabel'
                                value={endDate}
                                onChange={(newValue) => setEndDate(newValue)}
                                slotProps={{
                                  field: { clearable: true },
                                }}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <InputLabel htmlFor='positionDescriptionLabel'>
                            {t('labels.positionDescription')}
                          </InputLabel>
                          <textarea
                            id='positionDescription'
                            name='positionDescription'
                            disabled={!editMode}
                            value={positionDescription ?? ''}
                          />
                        </Grid>
                      </Grid>
                    </div>
                    <Grid
                      component='div'
                      container
                      className='setting-panel-header'
                      style={{ alignItems: 'center' }}
                    >
                      <QualificationsIcon />
                      <h3>{t('settings.titles.qualifications')}</h3>
                    </Grid>
                    <Divider />
                    <div className='setting-panel-body'>
                      <Grid component='div' container className='form-controls' spacing={4}>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            label={t('labels.degreeOrCertificate')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setDegree(e.target.value)
                            }
                            disabled={!editMode}
                            name='degree'
                            value={degree}
                          />
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            label={t('labels.institutionName')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setUniversityName(e.target.value)
                            }
                            disabled={!editMode}
                            name='universityName'
                            value={universityName}
                          />
                        </Grid>
                        <Grid
                          component='div'
                          size={{ xs: 12, md: 6 }}
                          className='datepicker-container'
                        >
                          <InputLabel id='startDateLabel'>{t('labels.startDate')}</InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
                            <DemoContainer components={['DatePicker']}>
                              <DatePicker
                                disabled={!editMode}
                                aria-labelledby='startDateLabel'
                                value={startDateQualifications}
                                format='DD.MM.YYYY'
                                onChange={(newValue) => setStartDateQualifications(newValue)}
                                slotProps={{
                                  field: { clearable: true },
                                }}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </Grid>
                        <Grid
                          component='div'
                          size={{ xs: 12, md: 6 }}
                          className='datepicker-container'
                        >
                          <InputLabel id='endDateLabel'>{t('labels.endDate')}</InputLabel>
                          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='en-gb'>
                            <DemoContainer components={['DatePicker']}>
                              <DatePicker
                                disabled={!editMode}
                                aria-labelledby='endDateLabel'
                                format='DD.MM.YYYY'
                                value={endDateQualifications}
                                onChange={(newValue: any) => setEndDateQualifications(newValue)}
                                slotProps={{
                                  field: { clearable: true },
                                }}
                              />
                            </DemoContainer>
                          </LocalizationProvider>
                        </Grid>
                      </Grid>
                    </div>
                    <Grid
                      component='div'
                      container
                      className='setting-panel-header'
                      style={{ alignItems: 'center' }}
                    >
                      <EmergencySettingsIcon />
                      <h3>{t('settings.titles.emergencyContact')}</h3>
                    </Grid>
                    <Divider />
                    <div className='setting-panel-body'>
                      <Grid component='div' container className='form-controls' spacing={4}>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            label={t('labels.fullName')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setFullNameEmergency(e.target.value)
                            }
                            name='fullNameEmergency'
                            disabled={!editMode}
                            value={fullNameEmergency}
                          />
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            type='email'
                            label={t('labels.email')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              // Replace upper case letters as the value is typed.
                              setEmailEmergency(normalizeEmailInput(e.target.value))
                            }
                            name='emailEmergency'
                            disabled={!editMode}
                            value={emailEmergency}
                            validators={['isEmail']}
                            errorMessages={[t('messages.emailNotValid')]}
                            sx={{ '& input': { textTransform: 'lowercase !important' } }}
                            slotProps={{
                              htmlInput: {
                                inputMode: 'email',
                                autoCapitalize: 'none',
                                autoCorrect: 'off',
                                spellCheck: false,
                                maxLength: 254,
                              },
                            }}
                          />
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            label={t('labels.phoneNumber')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setPhoneNumberEmergency(e.target.value)
                            }
                            disabled={!editMode}
                            name='phoneNumberEmergency'
                            value={phoneNumberEmergency}
                          />
                          {Boolean(fieldsErrors?.phone_number) && (
                            <FormHelperText error={true}>
                              {fieldsErrors?.phone_number?.join('.')}
                            </FormHelperText>
                          )}
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            label={t('labels.postalAddress')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) => {
                              setAddressEmergency(e.target.value);
                            }}
                            disabled={!editMode}
                            name='addressEmergency'
                            value={addressEmergency}
                          />
                          {Boolean(fieldsErrors?.postal_address) && (
                            <FormHelperText error={true}>
                              {fieldsErrors?.postal_address?.join('.')}
                            </FormHelperText>
                          )}
                        </Grid>
                        <Grid component='div' size={{ xs: 12, md: 6 }}>
                          <TextValidator
                            select
                            label={t('labels.relationship')}
                            onChange={(e: ChangeEvent<HTMLInputElement>) =>
                              setRelationship(e.target.value)
                            }
                            disabled={!editMode}
                            name='relationship'
                            value={relationship}
                          >
                            {relationshipArray.map((option) => (
                              <MenuItem
                                id={`employeeProfilePageForAdminRelationshipArrayMenuItem_${option}`}
                                key={option}
                                value={option}
                              >
                                {option}
                              </MenuItem>
                            ))}
                          </TextValidator>
                        </Grid>
                      </Grid>
                    </div>
                    <Grid
                      component='div'
                      container
                      className='setting-panel-header'
                      style={{ alignItems: 'center', marginBottom: '2rem' }}
                    >
                      <DescriptionIcon />
                      <h3>{t('settings.titles.documents')}</h3>
                    </Grid>
                    <Grid component='div' container>
                      <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label='simple table'>
                          <TableHead>
                            <TableRow>
                              <TableCell>{t('labels.documents')}</TableCell>
                              <TableCell align='left'>{t('labels.fileType')}</TableCell>
                              <TableCell align='center'>{t('labels.date')}</TableCell>
                              <TableCell align='center'>{t('labels.labels')}</TableCell>
                            </TableRow>
                          </TableHead>
                          {employeeDocuments && employeeDocuments.length > 0 ? (
                            employeeDocuments.map((employeeDocument: any) => (
                              <TableRow
                                id={`employeeProfilePageForAdminEmployeeDocumentRow_${employeeDocument.name}`}
                                key={employeeDocument.name}
                                sx={{
                                  '&:last-child td, &:last-child th': { border: 0 },
                                  '&:hover': { cursor: 'pointer', color: '#6414DB' },
                                }}
                                onClick={() => handleNavigateByRowClick(employeeDocument)}
                              >
                                <TableCell
                                  id={`employeeProfilePageForAdminEmployeeDocumentRowTableCell_${employeeDocument.name}`}
                                  component='th'
                                  scope='row'
                                >
                                  {employeeDocument.name}
                                </TableCell>
                                <TableCell
                                  id={`employeeProfilePageForAdminEmployeeDocumentRowTableCell2_${employeeDocument.name}`}
                                  align='center'
                                >
                                  {employeeDocument.du_filetype === 'bk' ? (
                                    <Tooltip
                                      title={t('labels.bkGeneratedDocument')}
                                      placement='top'
                                      arrow
                                    >
                                      <div
                                        id={`employeeProfilePageForAdminEmployeeDocumentRowDiv_${employeeDocument.name}`}
                                        className={
                                          'file-type-label ' + employeeDocument.du_filetype
                                        }
                                      >
                                        <Brand
                                          id={`employeeProfilePageForAdminEmployeeDocumentRowBrand_${employeeDocument.name}`}
                                        />
                                      </div>
                                    </Tooltip>
                                  ) : (
                                    <div
                                      id={`employeeProfilePageForAdminEmployeeDocumentRowDiv2_${employeeDocument.name}`}
                                      className={'file-type-label ' + employeeDocument.du_filetype}
                                    >
                                      {employeeDocument.du_filetype}
                                    </div>
                                  )}
                                </TableCell>
                                <TableCell
                                  id={`employeeProfilePageForAdminEmployeeDocumentRowTableCell3_${employeeDocument.name}`}
                                  align='center'
                                >
                                  {Helpers.timeStampToDateV2(employeeDocument.updated)}
                                </TableCell>
                                <TableCell
                                  id={`employeeProfilePageForAdminEmployeeDocumentRowTableCell4_${employeeDocument.name}`}
                                  align='center'
                                >
                                  {('du_types' in employeeDocument &&
                                    employeeDocument.du_types.length > 0) ||
                                  ('du_workflows' in employeeDocument &&
                                    employeeDocument.du_workflows.length > 0) ||
                                  ('customers' in employeeDocument &&
                                    employeeDocument.employees.length > 0) ||
                                  ('dc_types' in employeeDocument &&
                                    employeeDocument.dc_types.length > 0) ||
                                  ('dc_workflows' in employeeDocument &&
                                    employeeDocument.dc_workflows.length > 0) ? (
                                    <PopoverWithButton
                                      id={String(employeeDocument.id)}
                                      buttonText={String(
                                        ('du_types' in employeeDocument
                                          ? employeeDocument.du_types.length
                                          : 0) +
                                          ('du_workflows' in employeeDocument
                                            ? employeeDocument.du_workflows.length
                                            : 0) +
                                          ('dc_types' in employeeDocument
                                            ? employeeDocument.dc_types.length
                                            : 0) +
                                          ('dc_workflows' in employeeDocument
                                            ? employeeDocument.dc_workflows.length
                                            : 0) +
                                          ('customers' in employeeDocument
                                            ? employeeDocument.employees.length
                                            : 0)
                                      )}
                                    >
                                      <Stack
                                        id={`employeeProfilePageForAdminEmployeeDocumentRowStack_${employeeDocument.name}`}
                                        component='div'
                                        direction='row'
                                        sx={{
                                          alignItems: 'center',
                                          flexWrap: 'wrap',
                                          gap: '0.375rem',
                                          maxWidth: '200px',
                                          padding: '0.5rem',
                                        }}
                                      >
                                        {'du_types' in employeeDocument
                                          ? employeeDocument.du_types.map((el: any) => (
                                              <Chip
                                                id={`employeeProfilePageForAdminEmployeeDocumentRowChip_${employeeDocument.name}_${el}`}
                                                key={el}
                                                label={el}
                                              />
                                            ))
                                          : null}
                                        {'du_workflows' in employeeDocument
                                          ? employeeDocument.du_workflows.map((el: any) => (
                                              <Chip
                                                id={`employeeProfilePageForAdminEmployeeDocumentRowChip2_${employeeDocument.name}_${el}`}
                                                key={el}
                                                label={el}
                                              />
                                            ))
                                          : null}
                                        {'dc_types' in employeeDocument
                                          ? employeeDocument.dc_types.map((el: any) => (
                                              <Chip
                                                id={`employeeProfilePageForAdminEmployeeDocumentRowChip3_${employeeDocument.name}_${el}`}
                                                key={el}
                                                label={el}
                                              />
                                            ))
                                          : null}
                                        {'dc_workflows' in employeeDocument
                                          ? employeeDocument.dc_workflows.map((el: any) => (
                                              <Chip
                                                id={`employeeProfilePageForAdminEmployeeDocumentRowChip4_${employeeDocument.name}_${el}`}
                                                key={el}
                                                label={el}
                                              />
                                            ))
                                          : null}
                                        <Chip
                                          id={`employeeProfilePageForAdminEmployeeDocumentRowChip5_${employeeDocument.name}`}
                                          key='id'
                                          label={employee?.full_name}
                                        ></Chip>
                                      </Stack>
                                    </PopoverWithButton>
                                  ) : null}
                                </TableCell>
                              </TableRow>
                            ))
                          ) : (
                            <TableBody>
                              <TableRow>
                                <TableCell colSpan={4}>
                                  <Box sx={{ textAlign: 'center' }}>
                                    {t('messages.noDocuments')}
                                  </Box>
                                </TableCell>
                              </TableRow>
                            </TableBody>
                          )}
                        </Table>
                      </TableContainer>
                    </Grid>
                  </>
                )}
                {editMode && (
                  <Grid
                    component='div'
                    container
                    style={{
                      justifyContent: 'flex-end',
                      gap: '8px',
                      flexWrap: 'wrap',
                      marginTop: '16px',
                    }}
                  >
                    <Button
                      id='employeeProfilePageForAdminGoBackBtn'
                      type='button'
                      variant='contained'
                      size='medium'
                      className='btn-default btn-action-basic btn-transparent-initial btn-cancel'
                      onClick={() => {
                        navigate(ROUTES.EMPLOYEE_PROFILES);
                      }}
                    >
                      {t('buttons.goBack')}
                    </Button>
                    <Button
                      id='employeeProfilePageForAdminUpdateBtn2'
                      type='submit'
                      disabled={!canSubmit}
                      variant='contained'
                      className='btn-default btn-action-basic save-button'
                    >
                      {!userId ? t('buttons.save') : t('buttons.update')}
                    </Button>
                  </Grid>
                )}
                {pendingStatus ? <ProgressOverlay /> : ''}
              </ValidatorForm>
            </div>
          </Grid>
        </div>
      )}
      <DialogItem
        isErrorMessage={false}
        open={deleteEmployeeMessageVisible}
        title={
          deleteEmployeeMessageVisible
            ? t('dialogTitles.deleteEmployee')
            : t('dialogTitles.deleteDefault')
        }
        text={
          deleteEmployeeMessageVisible
            ? t('messages.deleteEmployeeDialog')
            : t('messages.deleteDefault')
        }
        noDefaultActionsRow={true}
        handleClose={() => {
          setDeleteEmployeeMessageVisible(false);
        }}
      >
        <Box
          className='buttons-row'
          sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-end', marginTop: 2 }}
        >
          <Button
            id='employeeProfilePageForAdminDeleteBtn'
            type='button'
            role='button'
            variant='outlined'
            size='medium'
            style={{ marginLeft: '0.5rem', marginBottom: '0.5rem' }}
            onClick={() => deleteEmployee()}
          >
            {t('buttons.delete')}
          </Button>
          <Button
            id='employeeProfilePageForAdminGoBackBtn2'
            type='button'
            role='button'
            variant='contained'
            size='medium'
            style={{ marginLeft: '0.5rem', marginBottom: '0.5rem' }}
            onClick={() => {
              setDeleteEmployeeMessageVisible(false);
            }}
          >
            {t('buttons.goBack')}
          </Button>
        </Box>
      </DialogItem>
      {isInviteDialogOpen && (
        <MessageModal
          open={isInviteDialogOpen}
          modalTitle={t('headers.invitation')}
          modalContent={
            bothEmailsSet ? (
              <div>
                <Typography gutterBottom>{t('messages.whichEmailToUse')}</Typography>
                <RadioGroup value={invitationEmail} onChange={handleEmailChange}>
                  {email && (
                    <FormControlLabel
                      id='employeeProfilePageForAdminInvitePersonalEmailOption'
                      value={email.toLowerCase()}
                      control={<Radio id='employeeProfilePageForAdminInvitePersonalEmailRadio' />}
                      label={email.toLowerCase()}
                    />
                  )}
                  {emailBusiness && (
                    <FormControlLabel
                      id='employeeProfilePageForAdminInviteBusinessEmailOption'
                      value={emailBusiness.toLowerCase()}
                      control={<Radio id='employeeProfilePageForAdminInviteBusinessEmailRadio' />}
                      label={emailBusiness.toLowerCase()}
                    />
                  )}
                </RadioGroup>
              </div>
            ) : (
              <Typography gutterBottom>
                {t('messages.invitationWillBeSentTo')}
                {invitationEmail}
              </Typography>
            )
          }
          actionButtonText={t('buttons.sendInvitation')}
          actionButtonFn={() => {
            handleCloseDialog();
            handleOkDialog();
          }}
          goBackButtonText={t('buttons.goBack')}
          onClose={handleCloseDialog}
          actionButtonDisabled={!invitationEmail}
        />
      )}
      {/*<Dialog open={isInviteDialogOpen} onClose={handleCloseDialog}>
        <DialogTitle sx={{ m: 0, p: 2 }}>
          {bothEmailsSet ? 'Select email for invitation' : 'Invitation'}
          <IconButton
            aria-label='close'
            onClick={handleCloseDialog}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          {bothEmailsSet ? (
            <div>
              <Typography gutterBottom>Which email to use?</Typography>
              <RadioGroup value={invitationEmail} onChange={handleEmailChange}>
                {email && <FormControlLabel value={email} control={<Radio />} label={email} />}
                {emailBusiness && (
                  <FormControlLabel
                    value={emailBusiness}
                    control={<Radio />}
                    label={emailBusiness}
                  />
                )}
              </RadioGroup>
            </div>
          ) : (
            <Typography gutterBottom>Invitation will be sent to {invitationEmail}</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={handleCloseDialog}>Cancel</Button>
          <Button
            onClick={() => {
              handleCloseDialog();
              handleOkDialog();
            }}
            variant='contained'
            disabled={!invitationEmail}
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>*/}
    </>
  );
};

export default EmployeeProfilePageForAdmin;
